/*
  BIONIKA (2026-09-01) — variáns-választó öngyógyítás.

  Miért kell:
  A Dawn 15 minden opció-kattintásra újrakéri a szekciót az EDDIGI választásokkal
  (`option_values=...`). A fogtechnikai termékeknél az opciók összefüggnek
  (pl. 3i anatómiai fej: az adott Átmérő+Hossz párhoz csak EGYETLEN Sulkus létezik),
  ezért a kattintás után gyakran érvénytelen kombináció megy fel. Ilyenkor a
  `product.selected_variant` null, és mivel a BIONIKA-réteg a pirulák bejelölését
  ehhez köti (lásd product-variant-options.liquid), a szerver úgy adja vissza az
  oldalt, hogy EGYETLEN pirula sincs bejelölve — a vásárló elveszti a saját,
  helyes választásait is, a kosárgomb pedig letiltva marad.

  Mit csinál:
  A picker minden újrarajzolása után
    1. visszaállítja a vásárló megjegyzett (és még érvényes) választásait,
    2. ahol egyetlen érvényes érték maradt, azt automatikusan bejelöli,
    3. és egyetlen `change`-dzsel újrakéri a szekciót, így a szerver már érvényes
       variánst renderel (ár, cikkszám, kosárgomb helyreáll).

  Globálisan töltjük (nem a termék-szekcióban), mert a kollekció-oldali quick-add
  modál a termék markupját injektálja, a beszúrt <script src> pedig nem futna le.
*/
(function () {
  'use strict';
  if (window.__bnkVariantAutoselect) return;
  window.__bnkVariantAutoselect = true;

  // szekció-azonosító -> { opciónév: érték } : a vásárló legutóbbi választásai
  var MEMORIA = Object.create(null);
  // szekció-azonosító -> hány automatikus javítás futott egymás után (végtelen ciklus ellen)
  var LANC = Object.create(null);
  var LANC_MAX = 4;

  function kulcs(vs) {
    return vs.dataset.section || vs.id || 'default';
  }

  function elerheto(el) {
    // A szerver a nem létező kombinációkat `class="disabled"`-del (pirula/swatch),
    // illetve `data-option-available="false"`-szal (legördülő) jelöli.
    if (el.dataset.optionAvailable === 'false') return false;
    if (el.classList && el.classList.contains('disabled')) return false;
    return true;
  }

  function csoportok(vs) {
    return Array.prototype.slice.call(
      vs.querySelectorAll('fieldset.product-form__input, .product-form__input--dropdown')
    );
  }

  // A legenda melletti „kiválasztott érték" felirat (swatch nézet) frissítése.
  function feliratFrissit(csoport, ertek) {
    var cimke = csoport.querySelector('[data-selected-value]');
    if (cimke && !cimke.querySelector('.swatch')) cimke.textContent = ertek;
  }

  function javit(vs) {
    var k = kulcs(vs);
    var mem = MEMORIA[k] || (MEMORIA[k] = Object.create(null));
    var valtozott = false;
    var utolso = null;

    // Érintetlen picker (friss termékoldal, még semmi nincs bejelölve): nem
    // döntünk a vásárló helyett — a tudatos opcióválasztás kikényszerítése
    // szándékos. Csak akkor lépünk közbe, ha már van/volt választás.
    if (
      vs.querySelector('input[type="radio"]') &&
      !vs.querySelector('input[type="radio"]:checked') &&
      !Object.keys(mem).length
    ) {
      LANC[k] = 0;
      return;
    }

    csoportok(vs).forEach(function (csoport) {
      var select = csoport.querySelector('select');

      if (select) {
        var opciok = Array.prototype.slice.call(select.options);
        var jelenlegi = select.selectedOptions[0];
        if (jelenlegi && elerheto(jelenlegi)) return;

        var emlekOpcio = opciok.filter(function (o) {
          return o.value === mem[o.dataset.optionName] && elerheto(o);
        })[0];
        var szabadOpciok = opciok.filter(elerheto);
        var valasztott = emlekOpcio || (szabadOpciok.length === 1 ? szabadOpciok[0] : null);
        if (!valasztott || valasztott === jelenlegi) return;

        opciok.forEach(function (o) { o.removeAttribute('selected'); });
        valasztott.selected = true;
        valasztott.setAttribute('selected', 'selected');
        valtozott = true;
        utolso = select;
        return;
      }

      var inputok = Array.prototype.slice.call(csoport.querySelectorAll('input[type="radio"]'));
      if (!inputok.length) return;

      // A szerver bejelölve IS visszaadhat olyan értéket, ami az új kombinációval
      // már nem létezik (a `selected` és az `available` két külön jelzés). Ilyenkor
      // a jelölést eldobjuk, különben beragadnánk egy „Nem elérhető" állapotba.
      var bejelolt = csoport.querySelector('input[type="radio"]:checked');
      if (bejelolt) {
        if (elerheto(bejelolt)) return;
        bejelolt.checked = false;
      }

      var nev = inputok[0].dataset.optionName;
      var emlek = mem[nev];
      var jelolt = null;

      if (emlek) {
        jelolt = inputok.filter(function (i) { return i.value === emlek && elerheto(i); })[0] || null;
      }
      if (!jelolt) {
        var szabad = inputok.filter(elerheto);
        // Csak akkor döntünk a vásárló helyett, ha nincs miből választani.
        if (szabad.length === 1) jelolt = szabad[0];
      }
      if (!jelolt) return;

      jelolt.checked = true;
      feliratFrissit(csoport, jelolt.value);
      valtozott = true;
      utolso = jelolt;
    });

    if (!valtozott || !utolso) { LANC[k] = 0; return; }

    LANC[k] = (LANC[k] || 0) + 1;
    if (LANC[k] > LANC_MAX) return; // biztonsági fék: nem kérünk újabb szekciót

    utolso.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // A vásárló saját választásait megjegyezzük, hogy egy érvénytelen köztes
  // állapot után vissza tudjuk állítani őket.
  document.addEventListener(
    'change',
    function (event) {
      var el = event.target;
      if (!el || !el.dataset || !el.dataset.optionName) {
        if (el && el.tagName === 'SELECT') el = el.selectedOptions[0];
        if (!el || !el.dataset || !el.dataset.optionName) return;
      }
      var vs = el.closest && el.closest('variant-selects');
      if (!vs) return;
      var k = kulcs(vs);
      (MEMORIA[k] || (MEMORIA[k] = Object.create(null)))[el.dataset.optionName] = el.value;
      if (event.isTrusted) LANC[k] = 0; // valódi kattintás: új lánc indul
    },
    true
  );

  // BIONIKA (2026-10-01) — sulkus-vezérelt hossz (product-variant-picker.liquid).
  // Ahol a sulkus egyértelműen meghatározza a hosszt, a Hossz-választó rejtett
  // rádiókká válik. Sulkus-választáskor a hozzá tartozó hosszt jelöljük be MÉG a
  // Dawn saját (bubbling) change-kezelője előtt, így az option_values már érvényes
  // kombinációt kér le.
  document.addEventListener(
    'change',
    function (event) {
      var el = event.target;
      if (el && el.tagName === 'SELECT') el = el.selectedOptions[0];
      if (!el || !el.dataset || el.dataset.bnkLenValue == null) return;
      var vs = el.closest && el.closest('variant-selects');
      var fs = vs && vs.querySelector('[data-bnk-dep-len]');
      if (!fs) return;
      var hossz = el.dataset.bnkLenValue;
      Array.prototype.forEach.call(fs.querySelectorAll('input[type="radio"]'), function (i) {
        i.checked = i.value === hossz;
      });
      var felirat = vs.querySelector('[data-bnk-dep-len-text]');
      if (felirat) felirat.textContent = hossz;
    },
    true
  );

  function bejar(gyoker) {
    if (gyoker.matches && gyoker.matches('variant-selects')) { javit(gyoker); return; }
    if (!gyoker.querySelectorAll) return;
    Array.prototype.forEach.call(gyoker.querySelectorAll('variant-selects'), javit);
  }

  // Szándékosan setTimeout és nem requestAnimationFrame: a rAF háttérfülben nem
  // fut le, így egy ott indított javítás a fül visszahozataláig beragadna (a
  // „fut már egy kör" jelző pedig minden továbbit is elnyelne).
  var utemezve = false;
  function utemez(csomopontok) {
    if (utemezve) return;
    utemezve = true;
    setTimeout(function () {
      var lista = csomopontok.slice();
      csomopontok.length = 0;
      utemezve = false;
      try {
        lista.forEach(bejar);
      } catch (e) {
        if (window.console) console.error('bnk-variant-autoselect', e);
      }
    }, 0);
  }

  var varolista = [];
  new MutationObserver(function (mutaciok) {
    mutaciok.forEach(function (m) {
      Array.prototype.forEach.call(m.addedNodes, function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches('variant-selects') || n.querySelector('variant-selects')) varolista.push(n);
      });
    });
    if (varolista.length) utemez(varolista);
  }).observe(document.documentElement, { childList: true, subtree: true });


  // BIONIKA (2026-10-06) — részleges méretválasztás. Amíg a vásárló nem választott
  // MINDEN (választható) opcióból, a szerver által feloldott variáns csak „tipp”:
  // nem mutatjuk a készletét és nem kényszerítjük rá a min. 10 db-ot, hanem a
  // termék összesített készletét („Válasszon méretet – N méret készleten”).
  // BIONIKA (2026-10-07): közvetlen variáns-link (?variant=…) — a vásárló már konkrét
  // variánst nyitott meg, ezért az oldal betöltésekor bejelölt értékek választásnak
  // számítanak (különben a nem készletes variáns min. 10-e elveszne). Termékoldalanként
  // (útvonal + szekció) csak egyszer, hogy a későbbi kattintások után (amikor a Dawn
  // maga írja a ?variant-ot az URL-be) a részleges választás logikája ne sérüljön.
  var URL_MAG = Object.create(null);
  function urlValasztas(vs) {
    var k = kulcs(vs);
    var jel = location.pathname + '|' + k;
    if (URL_MAG[jel]) return;
    URL_MAG[jel] = true;
    if (!/[?&]variant=\d/.test(location.search)) return;
    if (!vs.closest('product-info') || vs.closest('.quick-add-modal, quick-add-modal')) return;
    var mem = MEMORIA[k] || (MEMORIA[k] = Object.create(null));
    Array.prototype.forEach.call(vs.querySelectorAll('input[type="radio"]:checked, select'), function (e) {
      var el = e.tagName === 'SELECT' ? e.selectedOptions[0] : e;
      if (el && el.dataset.optionName && !(el.dataset.optionName in mem)) mem[el.dataset.optionName] = el.value;
    });
  }

  function hianyzoValasztas(vs) {
    urlValasztas(vs);
    var mem = MEMORIA[kulcs(vs)] || {};
    return csoportok(vs).some(function (csoport) {
      // 2026-10-09: checkVisibility csak stilust szamol, elrendezest nem kenyszerit (az offsetParent igen).
      if (csoport.hidden) return false;
      if (csoport.checkVisibility ? !csoport.checkVisibility() : csoport.offsetParent === null) return false;
      var elemek = Array.prototype.slice.call(csoport.querySelectorAll('input[type="radio"], option'));
      var nev = null;
      var szabad = elemek.filter(function (e) {
        if (e.dataset.optionName) nev = nev || e.dataset.optionName;
        return elerheto(e);
      });
      if (szabad.length <= 1 || !nev) return false;
      return !(nev in mem);
    });
  }

  function fuggoKeszlet() {
    Array.prototype.forEach.call(document.querySelectorAll('variant-selects[data-section]'), function (vs) {
      var id = vs.dataset.section;
      var p = document.getElementById('Inventory-' + id);
      if (!p || !p.dataset.bnkPendingText || !(parseInt(p.dataset.bnkInstock || '0', 10) > 0)) return;
      // 2026-10-09: ha a felirat mar kint van es a minimum is az alap, nincs teendo — ne merjunk ujra
      // (a dokumentum-szintu MutationObserver parse kozben sokszor hiv ide).
      var q0 = document.getElementById('Quantity-' + id);
      if (p.querySelector('.bnk-pend') && (!q0 || !q0.dataset.bnkMinBase ||
          parseInt(q0.dataset.min || '1', 10) <= (parseInt(q0.dataset.bnkMinBase, 10) || 1))) return;
      if (!hianyzoValasztas(vs)) return;
      if (!p.querySelector('.bnk-pend')) {
        var ikon = p.querySelector('.svg-wrapper');
        var html = ikon ? ikon.outerHTML : '';
        p.innerHTML = html + '<span class="bnk-pend">' + p.dataset.bnkPendingText + '</span>';
        var uj = p.querySelector('.svg-wrapper');
        if (uj) uj.style.color = 'rgb(62, 214, 96)';
        p.classList.remove('visibility-hidden');
      }
      var q = document.getElementById('Quantity-' + id);
      if (q && q.dataset.bnkMinBase) {
        var alap = parseInt(q.dataset.bnkMinBase, 10) || 1;
        var most = parseInt(q.dataset.min || '1', 10);
        if (most > alap) {
          q.dataset.min = alap; q.min = alap;
          if (parseInt(q.value || '0', 10) === most) q.value = alap;
        }
      }
    });
  }

  // Szinkron, a MutationObserver mikrotaszkjában — még a böngésző kirajzolása ELŐTT.
  // (2026-10-06: a korábbi setTimeout(0) miatt a szerver „Rendelhető” szövege egy
  // képkocka erejéig felvillant, mielőtt a „Válasszon méretet…” felülírta.)
  // Az fuggoKeszlet idempotens (.bnk-pend jelző), a saját módosítása okozta újabb
  // hívás nem csinál semmit.
  var fuggoFut = false;
  new MutationObserver(function () {
    if (fuggoFut) return;
    fuggoFut = true;
    try { fuggoKeszlet(); } catch (e) { if (window.console) console.error('bnk-pending-stock', e); }
    fuggoFut = false;
  }).observe(document.documentElement, { childList: true, subtree: true });

  function indul() { bejar(document); fuggoKeszlet(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', indul);
  else indul();
})();
